<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  width: 100%;
  padding-top: 120px;
  /* background-color: #fff; */
}
</style>




// WEBPACK FOOTER //
// src/App.vue